import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Avatar } from "primereact/avatar";
import { Rating } from "primereact/rating";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./schedules.css";
import { Timeline } from "primereact/timeline";
import defaultImg from "../../../assets/dummy-img.png";
import { toast } from "react-toastify";

import moment from "moment";
import { Tag } from "primereact/tag";
import { baseURL } from "../../../Config";
import { handleEncryptData } from "../../../services/EncryptionService";
import { handleDecryptData } from "../../../services/DecryptionService";
import { getSocket, SOCKET_ENDPOINTS } from "../../../services/Socket";
import { handleGetRequest } from "../../../services/GetTemplate";
import { handlePostRequest } from "../../../services/PostTemplate";

const MatchedRides = ({ rowData }) => {
    const [statusChanes, setStatusChanges] = useState("");
    const userId = useSelector((state) => state.authenticationSlice?.userId);
    const history = useHistory();
    const dispatch = useDispatch();
    const socket = getSocket();
    const [matchedList, setMatchedList] = useState([]);
    const [flotingBtn, setFlotingBtn] = useState();
    const [data, setData] = useState();
    const [scheduleId, setScheduleId] = useState("");
    const [filteredMatchedList, setFilteredMatchedList] = useState([]);
    const selectedUserType = useSelector((state) => state.authenticationSlice?.selectedUserType);
    useEffect(() => {
        socket.on(SOCKET_ENDPOINTS.NEW_REQUEST, (data) => {
            console.log(data, "res data");
            try {
                // Attempt decryption within the listener
                const decryptedResponse = handleDecryptData(data?.cipher); // Ensure you have a decrypt utility
                console.log(decryptedResponse, "decryptedResponse");
            } catch (error) {
                console.error("Error while decrypting data:", error);
            }
        });

        // Cleanup the socket listener when the component unmounts
        // return () => {
        //     socket.off('passengerRideCancellationListener');
        // };
    }, []);

    const handleMatchedList = async () => {
        try {
            let apiEndpoint = "";
            let payload = "";

            if (selectedUserType == "1") {
                // const apiEndpoint = `api/route/getrequests?routeId=${rowData?._id}`;

                apiEndpoint = "api/route/getrequests";
                payload = {
                    ownerId: userId,
                    routeId: rowData?._id,
                    // page: 1,
                };
            } else {
                apiEndpoint = "api/scheduleride/getmatcheddriver";
                payload = {
                    userId: userId,
                    isScheduled: rowData?.isScheduled,
                    scheduleId: rowData?._id,
                };
            }

            if (apiEndpoint) {
                const response = await dispatch(handlePostRequest(apiEndpoint, payload, true, true));

                setData(response.data);
                setFlotingBtn(response?.data?.data?.status === "started");
                setScheduleId(response?.data?.data?._id || response?.data?.data?.schedule?._id);
                setMatchedList(response?.data?.data?.nearestDriver || response?.data?.matchedPassengers);
            }
        } catch (error) {
            // console.error("Error fetching user vehicle list:", error);
        }
    };

    useEffect(() => {
        handleMatchedList();
        if (socket) {
            // Add socket listeners

            socket.on(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, (response) => {
                console.log("Matched passengerRideCancellationListener Listener:", response);
            });

            socket.on(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, (response) => {
                console.log("Matched refreshDriverRoutes Listener:", response);
            });
            // socket.on("passengerRideCancellationListener", passengerRideCancellationListener);
            // socket.on("refreshDriverRoutes", refreshDriverRoutesListener);

            // Cleanup function to remove listeners when the component unmounts or socket changes
            // return () => {
            //     socket.off("passengerRideCancellationListener", passengerRideCancellationListener);
            //     socket.off("refreshDriverRoutes", refreshDriverRoutesListener);

            //     console.log("Socket listeners removed");
            // };
        }
    }, [socket]); // Dependency array ensures the effect runs only when `socket` changes

    useEffect(() => {
        if (selectedUserType === "1") {
            if (matchedList && Array.isArray(matchedList)) {
                // Filter out objects with IDs in the rejected array
                const filteredList = matchedList.filter((match) => {
                    return !(match.rejected && match.rejected.length > 0) && match?.accepted === null;
                });

                setFilteredMatchedList(filteredList);
            }
        } else {
            if (data) {
                const filteredList = data?.data?.nearestDriver.filter((driver) => {
                    // Compare each driver's _id with the driverRequests array
                    // If _id is found in driverRequests, do not include it in the filtered list
                    const isDriverRequest = data?.data?.schedule.driverRequests.includes(driver._id);
                    return !isDriverRequest; // Only include if _id is NOT in driverRequests
                });

                // Step 3: Update the filtered list
                setFilteredMatchedList(filteredList);
            }
        }
    }, [matchedList, data]);

    const handleRejectRequestByPassanger = (matchedId) => {
        if (!matchedId) {
            console.error("Route ID or User ID is missing!");
            return;
        }

        const encryptedData = {
            routeId: matchedId,
            scheduleId: scheduleId,
        };

        const encryptData = handleEncryptData(encryptedData);
        // Emit the socket event
        socket.emit("rejectedRequestByPassenger", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse");
            if (decryptedResponse?.status === true) {
                handleMatchedList();
                // Extract IDs for the three conditions
                const myRequestIds = decryptedResponse?.data?.data?.schedule?.request || [];
                const acceptedIds = decryptedResponse?.data?.data?.schedule?.accepted || [];
                const rejectedIds = decryptedResponse?.data?.data?.schedule?.rejected || [];

                // Determine and set the status of the specific route
                const updatedStatus = {};
                decryptedResponse?.data?.data?.nearestDriver.forEach((passenger) => {
                    if (myRequestIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Requested";
                    } else if (acceptedIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Accepted";
                    } else if (rejectedIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Cancel";
                    }
                });

                // Update the state of the specific route
                setStatusChanges((prevStatus) => ({
                    ...prevStatus,
                    [matchedId]: updatedStatus[matchedId] || prevStatus[matchedId], // Update only the matched ID's status
                }));

                // Add socket listeners
                socket.on(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, (response) => {
                    console.log("Refresh driver routes:", response);
                    toast.info("Driver routes refreshed");
                    handleMatchedList();
                });
                socket.on(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, (response) => {
                    console.log("Passenger ride cancellation:", response);
                    toast.info("Passenger ride cancelled");
                    handleMatchedList();
                });
                socket.on("redirectPassengerToActiveRideListner", (response) => {
                    console.log("Redirect passenger to active ride:", response);
                    toast.info("Redirecting to active ride");
                    history.push("/passenger-ride");
                });
                socket.on("refreshPassengerScheduleListner", (response) => {
                    console.log("Refresh passenger schedule:", response);
                    toast.info("Passenger schedule refreshed");
                    handleMatchedList();
                });
                socket.on("passengerRideCancellationListner", (response) => {
                    console.log("Passenger ride cancellation:", response);
                    toast.info("Passenger ride cancelled");
                    handleMatchedList();
                });
                socket.on("driverCompleteRideListner", (response) => {
                    console.log("Driver complete ride:", response);
                    toast.info("Driver completed the ride");
                    handleMatchedList();
                });
            } else {
                console.error("Failed to cancel route:", decryptedResponse?.msg);
            }
        });
    };

    useEffect(() => {
        if (socket) {
            socket.on(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, (response) => {
                console.log("Refresh driver routes:", response);
                toast.info("Driver routes refreshed");
                handleMatchedList();
            });
            socket.on(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, (response) => {
                console.log("Passenger ride cancellation:", response);
                toast.info("Passenger ride cancelled");
                handleMatchedList();
            });
            socket.on("redirectPassengerToActiveRideListner", (response) => {
                console.log("Redirect passenger to active ride:", response);
                toast.info("Redirecting to active ride");
                history.push("/passenger-ride");
            });
            socket.on("refreshPassengerScheduleListner", (response) => {
                console.log("Refresh passenger schedule:", response);
                toast.info("Passenger schedule refreshed");
                handleMatchedList();
            });
            socket.on("passengerRideCancellationListner", (response) => {
                console.log("Passenger ride cancellation:", response);
                toast.info("Passenger ride cancelled");
                handleMatchedList();
            });
            socket.on("driverCompleteRideListner", (response) => {
                console.log("Driver complete ride:", response);
                toast.info("Driver completed the ride");
                handleMatchedList();
            });
        }

        return () => {
            if (socket) {
                socket.off(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES);
                socket.off(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER);
                socket.off("redirectPassengerToActiveRideListner");
                socket.off("refreshPassengerScheduleListner");
                socket.off("passengerRideCancellationListner");
                socket.off("driverCompleteRideListner");
            }
        };
    }, [socket, handleMatchedList]);

    const handleRejectRequest = (matchedId) => {
        if (!matchedId) {
            console.error("Route ID or User ID is missing!");
            return;
        }

        const encryptedData = {
            routeId: scheduleId,
            scheduleId: matchedId,
        };

        const encryptData = handleEncryptData(encryptedData);
        // Emit the socket event
        socket.emit("rejectRequestByDriver", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse");
            if (decryptedResponse?.status === true) {
                handleMatchedList();

                // Add socket listeners
                socket.on(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, (response) => {
                    console.log("Refresh driver routes:", response);
                    toast.info("Driver routes refreshed");
                    handleMatchedList();
                });
                socket.on(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, (response) => {
                    console.log("Passenger ride cancellation:", response);
                    toast.info("Passenger ride cancelled");
                    handleMatchedList();
                });
                socket.on("redirectPassengerToActiveRideListner", (response) => {
                    console.log("Redirect passenger to active ride:", response);
                    toast.info("Redirecting to active ride");
                    history.push("/passenger-ride");
                });
                socket.on("refreshPassengerScheduleListner", (response) => {
                    console.log("Refresh passenger schedule:", response);
                    toast.info("Passenger schedule refreshed");
                    handleMatchedList();
                });
                socket.on("passengerRideCancellationListner", (response) => {
                    console.log("Passenger ride cancellation:", response);
                    toast.info("Passenger ride cancelled");
                    handleMatchedList();
                });
                socket.on("driverCompleteRideListner", (response) => {
                    console.log("Driver complete ride:", response);
                    toast.info("Driver completed the ride");
                    handleMatchedList();
                });
            } else {
                console.error("Failed to cancel route:", decryptedResponse?.msg);
            }
        });
    };
    // console.log( matchedList[0]?.userId?._id,"matchedList[0]?.userId?._id");

    const handleAcceptRequest = (matchedId) => {
        if (!matchedId) {
            console.error("Matched ID is missing!");
            return;
        }

        const encryptedData = {
            routeId: scheduleId, // Assuming this identifies the route
            scheduleId: matchedId, // This is the specific request ID
        };

        // Encrypt and send the request
        const encryptData = handleEncryptData(encryptedData);
        socket.emit("sendRequestToPassenger", JSON.stringify(encryptData), async (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decryption utility
            console.log("sendRequestToPassenger Response", response);
            console.log("decryptedResponse sendRequestToPassenger", decryptedResponse);
            if (decryptedResponse) {
                const isDriver = true;

                // Extract IDs for the three conditions
                const myRequestIds = decryptedResponse?.data.myRequests || [];
                const acceptedIds = decryptedResponse?.data.accepted || [];
                const rejectedIds = decryptedResponse?.data.rejected || [];

                // Determine and set the status of the specific route
                const updatedStatus = {};
                decryptedResponse?.matchedPassengers.forEach((passenger) => {
                    if (myRequestIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Requested";
                    } else if (acceptedIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Accepted";
                    } else if (rejectedIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Cancel";
                    }
                });

                // Update the state of the specific route
                setStatusChanges((prevStatus) => ({
                    ...prevStatus,
                    [matchedId]: updatedStatus[matchedId] || prevStatus[matchedId], // Update only the matched ID's status
                }));
            } else {
                console.error("Failed to update route:", decryptedResponse?.msg);
            }
        });
    };
    const handleAcceptRequestByPassanger = (matchedId) => {
        if (!matchedId) {
            console.error("Matched ID is missing!");
            return;
        }

        const encryptedData = {
            routeId: matchedId, // Assuming this identifies the route
            scheduleId: scheduleId, // This is the specific request ID
        };

        // Encrypt and send the request
        const encryptData = handleEncryptData(encryptedData);
        socket.emit("rideRequest", JSON.stringify(encryptData), async (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decryption utility
            console.log("rideRequest Response", response);
            console.log("decryptedResponse RideRequest", decryptedResponse);
            if (decryptedResponse) {
                const isDriver = true;

                // Extract IDs for the three conditions
                const myRequestIds = decryptedResponse?.data?.data?.schedule?.request || [];
                const acceptedIds = decryptedResponse?.data?.data?.schedule?.accepted || [];
                const rejectedIds = decryptedResponse?.data?.data?.schedule?.rejected || [];

                // Determine and set the status of the specific route
                const updatedStatus = {};
                decryptedResponse?.data?.data?.nearestDriver.forEach((passenger) => {
                    if (myRequestIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Requested";
                    } else if (acceptedIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Accepted";
                    } else if (rejectedIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Cancel";
                    }
                });

                // Update the state of the specific route
                setStatusChanges((prevStatus) => ({
                    ...prevStatus,
                    [matchedId]: updatedStatus[matchedId] || prevStatus[matchedId], // Update only the matched ID's status
                }));
            } else {
                console.error("Failed to update route:", decryptedResponse?.msg);
            }
        });
    };

    useEffect(() => {
        if (data) {
            if (selectedUserType === "1") {
                // Extract IDs for the three conditions
                const myRequestIds = data?.data.myRequests || [];
                const acceptedIds = data?.data.accepted || [];
                const rejectedIds = data?.data.rejected || [];

                // Determine and set the status of the specific routes
                const updatedStatus = {};
                data?.matchedPassengers.forEach((passenger) => {
                    if (myRequestIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Requested";
                    } else if (acceptedIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Accepted";
                    } else if (rejectedIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Cancel";
                    }
                });

                // Update the state for all relevant routes
                setStatusChanges((prevStatus) => ({
                    ...prevStatus,
                    ...updatedStatus, // Merge the new statuses
                }));
            } else {
                const myRequestIds = data?.data?.schedule?.request || [];
                const acceptedIds = data?.data?.schedule?.accepted || [];
                const rejectedIds = data?.data?.schedule?.rejected || [];

                // Determine and set the status of the specific route
                const updatedStatus = {};
                data?.data?.nearestDriver.forEach((passenger) => {
                    if (myRequestIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Requested";
                    } else if (acceptedIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Accepted";
                    } else if (rejectedIds.includes(passenger._id)) {
                        updatedStatus[passenger._id] = "Cancel";
                    }
                });

                // Update the state of the specific route
                setStatusChanges((prevStatus) => ({
                    ...prevStatus,
                    ...updatedStatus, // Merge the new statuses
                }));
            }
        } else {
            console.error("Failed to update route:", data?.msg);
        }
    }, [data, setStatusChanges]); // Add dependencies to ensure the effect runs when `data` changes

    if (filteredMatchedList?.length === 0) {
        return <h4>No route Match</h4>;
    }
    return (
        <div className="custom-schedules-grid">
            {filteredMatchedList?.map((data) => (
                <div className="surface-card p-3">
                    <div className="flex flex-row p-ai-center justify-content-between">
                        <div className="flex flex-row p-ai-center">
                            <Avatar image={data?.userId?.profileImage ? `${baseURL}${data?.userId?.profileImage}` : defaultImg} size="large" shape="circle" style={{ backgroundColor: "inherit" }} />
                            {/* <Avatar image="path/to/profile.jpg" shape="circle" size="large" /> */}
                            <div className="ml-3">
                                <div className="p-text-bold mb-1 mt-3" style={{ fontWeight: "bold" }}>
                                    {`${data?.userId?.firstName || ""} ${data?.userId?.lastName || ""}`}
                                </div>
                                <Rating value={data?.userId?.totalRating} readOnly stars={data?.userId?.totalRatingCount} cancel={false} />
                            </div>
                        </div>
                        <div className="flex flex-row p-2 items-center">
                            {statusChanes[data._id] ? (
                                <span>{statusChanes[data._id]}</span>
                            ) : (
                                <>
                                    {selectedUserType === "1" ? (
                                        <>
                                            <Button style={{ background: "red" }} className="w-8 h-8 rounded-full bg-red-600 text-white flex justify-center items-center mx-1 shadow-md" onClick={() => handleRejectRequest(data._id)}>
                                                <i className="pi pi-times text-lg"></i>
                                            </Button>
                                            <Button style={{ background: "green" }} className="w-8 h-8 rounded-full bg-green-600 text-white flex justify-center items-center mx-1 shadow-md" onClick={() => handleAcceptRequest(data._id)}>
                                                <i className="pi pi-check text-lg"></i>
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            <Button style={{ background: "red" }} className="w-8 h-8 rounded-full bg-red-600 text-white flex justify-center items-center mx-1 shadow-md" onClick={() => handleRejectRequestByPassanger(data._id)}>
                                                <i className="pi pi-times text-lg"></i>
                                            </Button>
                                            <Button style={{ background: "green" }} className="w-8 h-8 rounded-full bg-green-600 text-white flex justify-center items-center mx-1 shadow-md" onClick={() => handleAcceptRequestByPassanger(data._id)}>
                                                <i className="pi pi-check text-lg"></i>
                                            </Button>
                                        </>
                                    )}
                                </>
                            )}
                            {/* Red "X" button */}
                        </div>
                    </div>

                    <hr className="my-3" />
                    <div className="flex flex-row justify-content-between items-center">
                        <div className="flex align-items-center text-white text-md">Date and Time</div>
                        <div className="flex align-items-center justify-content-between flex-wrap ml-2">
                            <div className="flex align-items-center">
                                <span className="font-semibold">{moment(data?.date).format("Do MMM, YYYY hh:mm A")}</span>
                            </div>
                            {/* <div className='flex align-items-center'>
                                <span className='font-semibold'>{data.date}</span>
                                <span className='mx-2 font-semibold'>{data.time}</span>
                            </div> */}
                        </div>
                    </div>

                    <div className="flex flex-row justify-content-between mt-1">
                        <Timeline
                            value={[
                                { status: data?.startPoint?.placeName ? data?.startPoint?.placeName : "Not found", icon: "pi pi-map-marker" },
                                { status: data?.endPoint?.placeName ? data?.endPoint?.placeName : "Not found", icon: "pi pi-flag" },
                            ]}
                            // value={events}
                            align="left"
                            className="custom-timeline"
                            marker={(item) => (
                                <span className={`p-timeline-event-icon p-pt-2 text-white`}>
                                    <i className={item?.icon} style={{ fontSize: "1.5rem" }}></i>
                                </span>
                            )}
                            content={(item) => (
                                <div className="flex flex-column">
                                    <span>{item.status}</span>
                                </div>
                            )}
                        />
                    </div>

                    <hr className="my-1" />
                    <div className="flex flex-column table-container">
                        <div className="table-row flex justify-content-between">
                            <div className="text-sm text-center flex-1">Distance</div>
                            {/* <div className="text-sm text-center flex-1">Match</div> */}
                            {/* <div className="text-sm text-center flex-1">Requests</div> */}
                            <div className="text-sm text-center flex-1">Duration</div>
                            <div className="text-sm text-center flex-1">Fare</div>
                            <div className="text-sm text-center flex-1">Booked</div>
                        </div>
                    </div>

                    <div className="flex flex-column m-3 mt-0">
                        <div className="table-row flex justify-content-between">
                            <div className="text-sm text-center flex-1">{data?.distance ? `${(data.distance / 1000).toFixed(2)} km` : "0 km"}</div>
                            {/* <div className="text-sm text-center flex-1">{data?.matchedCount || data?.matchCount || 0}</div> */}
                            {/* <div className="text-sm text-center flex-1">{data?.requestCount || data?.requestedCount || 0}</div> */}
                            <div className="text-sm text-center flex-1">{data?.duration ? `${Math.floor(data.duration / 3600)}h ${Math.floor((data.duration % 3600) / 60)}m` : "0h 0m"}</div>
                            <div className="text-sm text-center flex-1">{data?.fare}</div>
                            <div className="text-sm text-center flex-1">{data?.bookedSeats || 0}</div>
                        </div>
                    </div>
                    {/* <div className="flex text-center justify-content-center p-2">
                        <i className="pi pi-user mr-2"></i>
                        <Tag>{data?.status}</Tag>
                    </div> */}
                    {/* <div>
                        <Button
                            type="button"
                            className="block font-medium mx-auto mt-3 mb-3 text-lg w-9rem"
                            // label={data.events[0].status}
                            onClick={() => history.push("/ride-status")}
                        />
                    </div> */}
                </div>
            ))}
        </div>
    );
};

export default MatchedRides;
